import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

export const Warning = styled.div`
    color: red;
    font-size: 1.6rem;
    text-align: center;
`;
